import {getStateWithOnlyOneLevel} from '../utils/StateSelectorHelper';

const getState = state => getStateWithOnlyOneLevel(state, 'LoaderHandler');

export const getLoadingHandler = state => getState(state).get('loadingHandler');
